import { RunxRadarRedirectIFrame } from "components/organisms/RunxRadarRedirectIFrame";

const RunxRadarRedirect = () => {
  return <RunxRadarRedirectIFrame />;
};

export { RunxRadarRedirect };
